import {
  cloneSalesActionProducts as cloneSalesActionProductsApi,
  completeSalesAction as completeSalesActionApi,
  createSalesAction as createSalesActionApi,
  deleteSalesAction as deleteSalesActionApi,
  listSalesActions as listSalesActionsApi,
  patchSalesAction as patchSalesActionApi,
  restoreSalesActionStatus as restoreSalesActionStatusApi,
  updateSalesActionStatus as updateSalesActionStatusApi,
} from '@shared/api/sales-actions';
import type {
  PagedSalesActions,
  SalesAction,
  SalesActionCompleteRequest,
  SalesActionCreateRequest,
  SalesActionListQuery,
  SalesActionPatchRequest,
  SalesActionProductClonesRequest,
  SalesActionProductClonesResponse,
  SalesActionStatusUpdateRequest,
} from '@shared/types/sales-action';

interface ListState {
  data: PagedSalesActions | null;
  loading: boolean;
  error: string | null;
}

const listState = $state<ListState>({ data: null, loading: false, error: null });
let listToken = 0;

export const salesActionListStore = {
  get data(): PagedSalesActions | null {
    return listState.data;
  },
  get loading(): boolean {
    return listState.loading;
  },
  get error(): string | null {
    return listState.error;
  },
  async refresh(query: SalesActionListQuery): Promise<void> {
    const token = ++listToken;
    listState.loading = true;
    listState.error = null;
    try {
      const data = await listSalesActionsApi(query);
      if (token !== listToken) return;
      listState.data = data;
    } catch (err) {
      if (token !== listToken) return;
      listState.error = err instanceof Error ? err.message : String(err);
    } finally {
      if (token === listToken) listState.loading = false;
    }
  },
  clear(): void {
    listState.data = null;
    listState.error = null;
  },
};

export async function createSalesAction(
  body: SalesActionCreateRequest,
): Promise<SalesAction> {
  return createSalesActionApi(body);
}

export async function patchSalesAction(
  id: string,
  body: SalesActionPatchRequest,
): Promise<SalesAction> {
  return patchSalesActionApi(id, body);
}

export async function deleteSalesAction(id: string): Promise<void> {
  return deleteSalesActionApi(id);
}

export async function completeSalesAction(
  id: string,
  body: SalesActionCompleteRequest,
): Promise<SalesAction> {
  return completeSalesActionApi(id, body);
}

export async function updateSalesActionStatus(
  id: string,
  body: SalesActionStatusUpdateRequest,
): Promise<SalesAction> {
  return updateSalesActionStatusApi(id, body);
}

export async function restoreSalesActionStatus(id: string): Promise<SalesAction> {
  return restoreSalesActionStatusApi(id);
}

export async function cloneSalesActionProducts(
  id: string,
  body: SalesActionProductClonesRequest,
): Promise<SalesActionProductClonesResponse> {
  return cloneSalesActionProductsApi(id, body);
}
